import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EditableComponent } from "src/app/components/ui/editable/editable.component";
import {
  DxAutocompleteModule,
  DxCheckBoxModule,
  DxDateBoxModule,
  DxFormModule,
  DxLookupModule,
  DxPopoverModule,
  DxSelectBoxModule,
  DxTextBoxModule
} from "devextreme-angular";
import { TranslocoModule } from "@jsverse/transloco";
import { ButtonModule } from "src/app/components/ui/button/button.module";
import { DirectivesModule } from "src/app/modules/bootstrap/directives/directives.module";
import { FiscalCodeHelperModule } from "src/app/components/ui/fiscal-code-helper/fiscal-code-helper.module";
import { EditableSelectBoxItemTemplateDirective } from "src/app/components/ui/editable/editable-select-box-item-template.directive";
import { EditableAddressComponent } from "src/app/components/ui/editable/editable-address/editable-address.component";
import { WysiwygEditorModule } from "src/app/components/ui/wysiwyg-editor/wysiwyg-editor.module";
import { PipesModule } from "src/app/pipes/pipes.module";
import { AddressCheckerFunctionModule } from "src/app/modules/bootstrap/pms-ui/functions/address/address-checker/address-checker-function.module";
import { MailtoComponent } from "src/app/components/ui/mailto/mailto.component";
import { TagBoxModule } from "src/app/components/ui/tag-box/tag-box.module";

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,

    DxFormModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxLookupModule,
    DxAutocompleteModule,
    DxCheckBoxModule,
    DxDateBoxModule,

    ButtonModule,
    DirectivesModule,
    FiscalCodeHelperModule,
    WysiwygEditorModule,
    PipesModule,
    DxPopoverModule,
    AddressCheckerFunctionModule,
    MailtoComponent,
    TagBoxModule
  ],
  declarations: [
    EditableComponent,
    EditableAddressComponent,
    EditableSelectBoxItemTemplateDirective
  ],
  exports: [EditableComponent, EditableSelectBoxItemTemplateDirective]
})
export class EditableModule {}
